import { REFRESH_TOKEN } from '../common/constants/localStorage';
import { useAxios } from './axiosService';
import { getToken } from './tokenService';

export const useAuthService = () => {
    const { axios } = useAxios();

    const signInEmailPassword = async credentials => {
        return await axios.post('/auth/sign-in', { credentials });
    };

    const signUpEmailPassword = async credentials => {
        return await axios.post('/auth/sign-up', { credentials });
    };

    const googleAuth = async (path, code) => {
        const language = navigator.language.slice(0, 2);
        return await axios.post(`/auth/google/${path}`, { code, language });
    };

    const facebookAuth = async (path, code) => {
        return await axios.post(`/auth/facebook/${path}`, { code });
    };

    const getGeneratedQr = async () => {
        return await axios.get('/2fa/generate-qr');
    };

    const enableTwoFactorAuth = async code => {
        return await axios.post('/2fa/enable-two-factor-auth', { code });
    };

    const disableTwoFactorAuth = async code => {
        return await axios.post('/2fa/disable-two-factor-auth', { code });
    };

    const twoFactorAuth = async code => {
        return await axios.post('/2fa/authenticate', { code });
    };

    // Super Admin only: switches off another user's 2FA, confirmed with the admin's own code
    const resetTwoFactorAuth = async (userId, code) => {
        return await axios.post(`/2fa/users/${userId}/reset`, { code });
    };

    const changeTeam = async teamId => {
        return await axios.post(`/auth/change-team`, { teamId });
    };

    const validateInvitationToken = async token => {
        return await axios.post(`/auth/validate-invitation-token`, {
            token: token,
        });
    };

    const validateRestoreToken = async token => {
        return await axios.post(`/auth/validate-restore-token`, {
            token: token,
        });
    };

    const finishInvitation = async data => {
        return await axios.post(`/auth/finish-invitation`, data);
    };

    const forgotPassword = async email => {
        return await axios.post(`/auth/forgot-password`, {
            email: email,
        });
    };

    const decryptPreviewLink = async hash => {
        return await axios.post(`/demo/preview`, { hash });
    };

    const logout = async () => {
        return await axios.post('/auth/logout', { refreshToken: getToken(REFRESH_TOKEN) });
    };

    return {
        signInEmailPassword,
        signUpEmailPassword,
        googleAuth,
        facebookAuth,
        getGeneratedQr,
        enableTwoFactorAuth,
        disableTwoFactorAuth,
        twoFactorAuth,
        resetTwoFactorAuth,
        changeTeam,
        finishInvitation,
        validateInvitationToken,
        validateRestoreToken,
        forgotPassword,
        decryptPreviewLink,
        logout,
    };
};
